<template>
  <div class="product-thumb">
    <div>
      <router-link
        class="product-thumb__link"
        :to="data.link || data.permalink"
      >
        <Media
          v-if="data.gds_featured_image"
          :data="{
            type: 'image',
            image: data.gds_featured_image,
            ratio: 3 / 4,
            object_fit: 'cover',
          }"
        />
        <Title
          class="thumb__title"
          :data="{
            value: data.taxonomy || data.name ? data.name : data.title.rendered,
            size: 'm',
            tag: 'h4',
          }"
        />
      </router-link>
      <Spacer top="xxs">
        <Price :product="data" />
        <Availability :product="data" />
      </Spacer>
    </div>
    <Cta
      v-if="!hasVariations"
      theme="button"
      :data="{
        title: labelCart,
        url: false,
        fn: addToCart,
      }"
      :disabled="!addableToCart"
    />
    <Cta
      v-else
      theme="button"
      :data="{
        title: $labels.select_option,
        url: data.link || data.permalink,
      }"
    />
  </div>
</template>

<script>
import { addableToCart, isOos } from '@/assets/js/utils-wc';

import Media from '@/components/blocks/media';
import Title from '@/components/typo/title';
import Cta from '@/components/typo/cta';
import Price from '@/components/wc/price.vue';
import Availability from '@/components/wc/availability.vue';

export default {
  name: 'Thumb',
  components: {
    Media,
    Title,
    Cta,
    Price,
    Availability,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'link',
    },
  },
  data() {
    return {
      labelCart: this.$labels.add_to_cart,
      timeoutCart: null,
    };
  },
  computed: {
    isOos() {
      return isOos(this.data);
    },
    hasVariations() {
      return this.data.type.startsWith('variable');
    },
    addableToCart() {
      if (!addableToCart(this.data) || isOos(this.data)) {
        return false;
      }
      return true;
    },
  },
  beforeDestroy() {
    if (this.timeoutCart !== null) {
      clearTimeout(this.timeoutCart);
    }
  },
  methods: {
    addToCart() {
      if (this.timeoutCart !== null) {
        clearTimeout(this.timeoutCart);
      }
      this.labelCart = this.$labels.added_to_cart;

      this.timeoutCart = setTimeout(() => {
        this.labelCart = this.$labels.add_to_cart;
      }, 2000);

      this.$store.dispatch(
        'addToCart',
        Object.assign(this.data, {
          id: String(this.data.id),
          quantity: 1,
          quantityDelta: 1,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .product-thumb {
    display: grid;
    height: 100%;
    row-gap: var(--row-gap-l);
    align-content: space-between;

    &__link {
      display: grid;
      row-gap: var(--row-gap-s);
    }

    .cta {
      width: 100%;
      justify-content: center;
      align-self: end;
    }
  }
</style>
